import { FormattedMessage } from "react-intl";
import React, { Fragment } from "react";
import _ from "lodash";

import { Icon } from "../../../../components/icon/Icon";
import { SecurityCategoryKeys } from "../../store";

const AllowedCategory = () => {
  return (
    <div className="domain-lookup__table-cell">
      <div className={"category__icon"} aria-hidden={true}>
        <Icon icon="fa-regular fa-check color-success" />
      </div>
      <div className={"category__status"}>
        <FormattedMessage id={"allowed"} />
      </div>
    </div>
  );
};
const BlockedCategory = () => {
  return (
    <div className="domain-lookup__table-cell">
      <div className={"category__icon"} aria-hidden={true}>
        <Icon icon="fa-regular fa-ban color-danger" />
      </div>
      <div className={"category__status"}>
        <FormattedMessage id={"blocked"} />
      </div>
    </div>
  );
};
const BlockedProfiles = ({ profiles }) => {
  return (
    <div className="domain-lookup__table-cell">
      <div className={"category__icon"}>
        <Icon icon="fa-regular fa-ban color-danger" />
      </div>
      <div className={"category__status"}>{profiles.join(", ")}</div>
    </div>
  );
};
const AllowedProfiles = ({ profiles }) => {
  return (
    <div className="domain-lookup__table-cell">
      <div className={"category__icon"}>
        <Icon icon="far fa-check color-success" />
      </div>
      <div className={"category__status"}>{profiles.join(", ")}</div>
    </div>
  );
};

const SSProfilesStatus = ({
  allowedSSProfiles,
  blockedSSProfiles,
  showProfiles,
}) => {
  return (
    <div className="domain-lookup__table-cell-wrapper">
      {_.isEmpty(blockedSSProfiles) ? null : showProfiles ? (
        <BlockedProfiles profiles={blockedSSProfiles} />
      ) : (
        <BlockedCategory />
      )}
      {_.isEmpty(allowedSSProfiles) ? null : showProfiles ? (
        <AllowedProfiles profiles={allowedSSProfiles} />
      ) : (
        <AllowedCategory />
      )}
    </div>
  );
};

export const CategoryStatus = ({
  allowedSSProfiles,
  blockedSSProfiles,
  category,
  profiles,
  showProfiles = true,
}) => {
  if (!_.isEmpty(profiles) && showProfiles) {
    return <BlockedProfiles profiles={profiles} />;
  }

  switch (category.name) {
    case SecurityCategoryKeys.Botnet:
      return <BlockedCategory />;
    case SecurityCategoryKeys.Malware:
    case SecurityCategoryKeys.Phishing:
    case SecurityCategoryKeys.Spam:
    case SecurityCategoryKeys.Unidentified:
      return (
        <SSProfilesStatus
          allowedSSProfiles={allowedSSProfiles}
          blockedSSProfiles={blockedSSProfiles}
          showProfiles={showProfiles}
        />
      );
    default:
      return _.isEmpty(profiles) ? <AllowedCategory /> : <BlockedCategory />;
  }
};

export const COLUMNS_NOT_MOBILE = [
  {
    Header: (
      <FormattedMessage id={"associated_category_domainlookup_table_header"} />
    ),
    headerTranslationId: "associated_category_domainlookup_table_header",
    accessor: "name",
    sortable: true,
  },
  {
    Header: <FormattedMessage id={"blocked_profiles"} />,
    accessor: "associatedProfiles",
    sortable: false,
    Cell: ({ row: { original } }) => (
      <CategoryStatus
        category={original.category}
        profiles={original.associatedProfiles}
        allowedSSProfiles={original.allowedSSProfiles}
        blockedSSProfiles={original.blockedSSProfiles}
      />
    ),
  },
];

export const COLUMNS_MOBILE = [
  {
    accessor: "name",
    Cell: ({ row: { original } }) => (
      <Fragment>
        <div>{original.name}</div>
        <CategoryStatus
          category={original.category}
          profiles={original.associatedProfiles}
          allowedSSProfiles={original.allowedSSProfiles}
          blockedSSProfiles={original.blockedSSProfiles}
        />
      </Fragment>
    ),
  },
];

export const COLUMNS_NOT_MOBILE_SINGLE = [
  {
    Header: (
      <FormattedMessage id={"associated_category_domainlookup_table_header"} />
    ),
    headerTranslationId: "associated_category_domainlookup_table_header",
    accessor: "name",
    sortable: true,
    Cell: ({ row: { original } }) => <span>{original.name}</span>,
  },
  {
    Header: <FormattedMessage id={"category_status"} />,
    accessor: "associatedProfiles",
    sortable: false,
    Cell: ({ row: { original } }) => (
      <CategoryStatus
        profiles={original.associatedProfiles}
        showProfiles={false}
        category={original.category}
        allowedSSProfiles={original.allowedSSProfiles}
        blockedSSProfiles={original.blockedSSProfiles}
      />
    ),
  },
];

export const COLUMNS_MOBILE_SINGLE = [
  {
    accessor: "name",
    Cell: ({ row: { original } }) => (
      <Fragment>
        <div>{original.name}</div>
        <CategoryStatus
          profiles={original.associatedProfiles}
          showProfiles={false}
          category={original.category}
          allowedSSProfiles={original.allowedSSProfiles}
          blockedSSProfiles={original.blockedSSProfiles}
        />
      </Fragment>
    ),
  },
];
